import react from '../assets/projects/react.png'
import hookbank from '../assets/projects/hookbank.png'
import macosta from '../assets/projects/macosta.png'

export const data=[
    {
        id:1,
        name:"React JS Application",
        image:react,
        github:"",
        live:"",
    },
    {
        id:2,
        name:"React JS Application",
        image:hookbank,
        github:"",
        live:"",
    },
    {
        id:3,
        name:"React JS Application",
        image:macosta,
        github:"",
        live:"",
    },
   


]